import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchJSON, putJSON } from 'api/fetch';

export const fetchBankAccounts = createAsyncThunk(
  'payrollBankAccounts/fetchBankAccounts',
  () => fetchJSON('/payroll/bank_accounts')
);

export const updateBankAccount = createAsyncThunk(
  'payrollBankAccounts/updateBankAccount',
  ({ id, body }: { id: number; body: object }) =>
    putJSON(`/payroll/bank_accounts/${id}/update_nickname`, body)
);
